import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type UpdateDeliveryOrderMutationVariables = Types.Exact<{
  id: Types.Scalars['bigint']['input'];
  set: Types.Delivery_Orders_Set_Input;
}>;


export type UpdateDeliveryOrderMutation = { __typename?: 'mutation_root', update_delivery_orders_by_pk?: { __typename?: 'delivery_orders', id: number, order_number: string, recipient_business: string } | null };


export const UpdateDeliveryOrderDocument = gql`
    mutation updateDeliveryOrder($id: bigint!, $set: delivery_orders_set_input!) {
  update_delivery_orders_by_pk(pk_columns: {id: $id}, _set: $set) {
    id
    order_number
    recipient_business
  }
}
    `;
export type UpdateDeliveryOrderMutationFn = Apollo.MutationFunction<UpdateDeliveryOrderMutation, UpdateDeliveryOrderMutationVariables>;

/**
 * __useUpdateDeliveryOrderMutation__
 *
 * To run a mutation, you first call `useUpdateDeliveryOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliveryOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliveryOrderMutation, { data, loading, error }] = useUpdateDeliveryOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdateDeliveryOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeliveryOrderMutation, UpdateDeliveryOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeliveryOrderMutation, UpdateDeliveryOrderMutationVariables>(UpdateDeliveryOrderDocument, options);
      }
export type UpdateDeliveryOrderMutationHookResult = ReturnType<typeof useUpdateDeliveryOrderMutation>;
export type UpdateDeliveryOrderMutationResult = Apollo.MutationResult<UpdateDeliveryOrderMutation>;
export type UpdateDeliveryOrderMutationOptions = Apollo.BaseMutationOptions<UpdateDeliveryOrderMutation, UpdateDeliveryOrderMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/partsDelivery/queries/updateDeliveryOrder.mutation.gql}
 */
export async function updateDeliveryOrder(
  variables: UpdateDeliveryOrderMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateDeliveryOrderMutation['update_delivery_orders_by_pk']>
export async function updateDeliveryOrder(
  variables: UpdateDeliveryOrderMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateDeliveryOrderMutation>
export async function updateDeliveryOrder(
  variables: UpdateDeliveryOrderMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateDeliveryOrderMutation['update_delivery_orders_by_pk'] | UpdateDeliveryOrderMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateDeliveryOrderMutation>(
    UpdateDeliveryOrderDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_delivery_orders_by_pk
}